export default __webpack_public_path__ + "865350d308c617789269bdb4e4b43828.svg";